import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "site-navigator" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "router-logo" }, null, -1)
const _hoisted_3 = { class: "router-minibar" }
const _hoisted_4 = { class: "router-link" }
const _hoisted_5 = { class: "router-link" }
const _hoisted_6 = { class: "router-link" }
const _hoisted_7 = { class: "router-link" }
const _hoisted_8 = { class: "router-settings" }
const _hoisted_9 = { class: "settings-language-container" }
const _hoisted_10 = { class: "settings-language-choice" }
const _hoisted_11 = { class: "router-link" }
const _hoisted_12 = { class: "router-link-burger" }
const _hoisted_13 = { class: "router-link-burger" }
const _hoisted_14 = { class: "router-link-burger" }
const _hoisted_15 = { class: "router-link-burger" }
const _hoisted_16 = { class: "language-box" }

import { ref } from "vue";
import { useLanguage } from "@/composables/useLanguage";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const { lang, t, setLang } = useLanguage();

const burgerOpen = ref(false);
const langMenuOpen = ref(false);

function toggleBurger() {
  burgerOpen.value = !burgerOpen.value;
}

function closeBurger() {
  burgerOpen.value = false;
}

function toggleLangMenu() {
  langMenuOpen.value = !langMenuOpen.value;
}

function changeLanguage(newLang: "EN" | "KA") {
  setLang(newLang);
  langMenuOpen.value = false;
  // No page reload needed — the shared `lang` ref drives reactive re-renders.
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        id: "homeButtonLogo",
        onClick: closeBurger
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/contacts",
            onClick: closeBurger
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t).Navbar[0]), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/about",
            onClick: closeBurger
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t).Navbar[1]), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/product",
            onClick: closeBurger
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t).Navbar[2]), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, {
            to: "/gallery",
            onClick: closeBurger
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t).Navbar[3]), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "settings-language languageButton",
            onClick: toggleLangMenu
          }, _toDisplayString(_unref(lang) === "KA" ? "GE" : "EN"), 1),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "languageButton",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLanguage('EN')))
            }, " EN "),
            _createElementVNode("button", {
              class: "languageButton",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('KA')))
            }, " GE ")
          ], 512), [
            [_vShow, langMenuOpen.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_router_link, {
            class: "default-button-container",
            to: "/buy",
            onClick: closeBurger
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t).Navbar[4]), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("button", {
        onClick: toggleBurger,
        id: "navbarBurgerMenu",
        class: "navbar-burger-menu"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["burger-menu-line", { 'yellow-background': burgerOpen.value }])
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", {
      id: "navbarBurgerContainer",
      class: _normalizeClass({ 'burger-active': burgerOpen.value })
    }, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          class: "router-link-class",
          to: "/contacts",
          onClick: closeBurger
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t).Navbar[0]), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "router-link-class",
          to: "/about",
          onClick: closeBurger
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t).Navbar[1]), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, {
          class: "router-link-class",
          to: "/product",
          onClick: closeBurger
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t).Navbar[2]), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "router-link-class",
          to: "/gallery",
          onClick: closeBurger
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t).Navbar[3]), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "languageButton",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage('EN')))
        }, "EN"),
        _createElementVNode("button", {
          class: "languageButton",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeLanguage('KA')))
        }, "GE")
      ])
    ], 2)
  ], 64))
}
}

})